import { Types } from "mdui/form/MDForm";

const hideEditBtn = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    // Check if pageAction is 'search'
    if (props.pageAction !== 'search') {
        return;
    }

    // Get msStatus or mcStatus from formData
    // When called from onChange, formData already contains the updated value
    // Also check if the current field being changed is msStatus/mcStatus
    let msStatus = '';
    
    // Check if the current field is msStatus or mcStatus
    if (props.field && (props.field.name === 'msStatus' || props.field.name === 'mcStatus')) {
        // Get the value from the updated formData (which includes the new value)
        msStatus = formData?.[props.field.name] || '';
    } else {
        // Otherwise check both variations in formData
        msStatus = formData?.msStatus || formData?.mcStatus || '';
    }
    
    const shouldHideEdit = msStatus && msStatus.trim() !== '';

    // Get current page configuration
    const currentPage = config.pages[config.cPKey];
    if (!currentPage || !currentPage.config || !currentPage.config.tabs) {
        return;
    }

    const updtFormData = { ...formData, table:{} };
    // Create updated config with new references for React to detect changes
    // Since we modified the table field objects directly, we need to create new references
    // for the nested structures so React sees them as changed
    const updatedConfig = {
        ...config,
        pages: {
            ...config.pages,
            [config.cPKey]: {
                ...config.pages[config.cPKey],
                data: updtFormData,
                config: {
                    ...config.pages[config.cPKey].config,
                    tabs: config.pages[config.cPKey].config.tabs.map(tab => ({
                        ...tab,
                        groups: tab.groups?.map(group => ({
                            ...group,
                            fields: group.fields?.map(field => {
                                // Process table fields
                                if (field.type === Types.TBL) {
                                    const updatedField = { ...field };
                                                                 
                                    // Update fields array for edit action fields
                                    if (updatedField.fields && Array.isArray(updatedField.fields)) {
                                        updatedField.fields = updatedField.fields.map(f => {
                                            // Check if the field name is "action" and it has a fields array
                                            if (f.name === 'action' && f.fields && Array.isArray(f.fields)) {
                                                // Iterate the fields array and check if name is "edit"
                                                const updatedActionField = {
                                                    ...f,
                                                    fields: f.fields.map(actionField => {
                                                        if (actionField.name === 'edit') {
                                                            return { ...actionField, hide: shouldHideEdit };
                                                        }
                                                        return actionField;
                                                    })
                                                };
                                                return updatedActionField;
                                            }
                                            
                                            // Check if this field is an edit action (direct edit field)
                                            if (f.fnName === 'edit' || f.action === 'edit' || 
                                                (f.type === 'button' && f.label?.toLowerCase().includes('edit'))) {
                                                return { ...f, hide: shouldHideEdit };
                                            }
                                            return f;
                                        });
                                    }
                                    
                                    return updatedField;
                                }
                                return field;
                            }) || []
                        })) || []
                    })) || config.pages[config.cPKey].config.tabs
                }
            }
        }
    };

    // Update the config
    if (setCfg) {
        setCfg(updatedConfig);
    }
}

const fillGenBankCode = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    console.log("@@@",formData)
    let val = formData[props.field.fldNm];
    if (props.field.callbackArgs) {
        let newFormData = { ...formData, [props.field.callbackArgs]: val}
        updateState({ newFormData })
    }
}

const iniatationDtCal = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    console.log("@@@", formData);

    let val = formData["nextRqstExecutionDate"];
    const nonBusinessAdjDay = formData["nonBusinessDayAdj"];

    if (!val) {
        console.warn("nextRqstExecutionDate is empty");
        return;
    }

    // --------- Parse dd-MM-yyyy properly ---------
    const parseDMY = (str) => {
        const [dd, mm, yyyy] = str.split("-");
        return new Date(`${yyyy}-${mm}-${dd}`);
    };

    const baseDate = parseDMY(val);

    const isWeekend = (d) => {
        const day = d.getDay();
        return day === 0 || day === 6; // Sunday or Saturday
    };

    const getPreviousWorkingDay = (d) => {
        const date = new Date(d);
        do {
            date.setDate(date.getDate() - 1);
        } while (isWeekend(date));
        return date;
    };

    const getNextWorkingDay = (d) => {
        const date = new Date(d);
        do {
            date.setDate(date.getDate() + 1);
        } while (isWeekend(date));
        return date;
    };

    let nextInitiationDate;

    // -------------------------------------------------
    // IF baseDate is a working day => use same date
    // -------------------------------------------------
    if (!isWeekend(baseDate)) {
        nextInitiationDate = baseDate;
    } else {
        // If holiday/weekend apply nonBusinessDayAdj rule
        nextInitiationDate =
            nonBusinessAdjDay === "P"
                ? getPreviousWorkingDay(baseDate)
                : getNextWorkingDay(baseDate);
    }

    // --------- Format dd-MM-yyyy ---------
    const pad = (n) => (n < 10 ? `0${n}` : n);
    const formatted = `${pad(nextInitiationDate.getDate())}-${pad(
        nextInitiationDate.getMonth() + 1
    )}-${nextInitiationDate.getFullYear()}`;
    // --------------------------------------

    console.log("formatted:", formatted);

    const newFormData = {
        ...formData,
        nextInitiationDate: formatted,
    };

    updateState({ newFormData });
};





export { hideEditBtn ,fillGenBankCode,iniatationDtCal}